<template>
  <Card title="Personal Details" margin="">
    <template #actions>
      <button class="btn btn-sm btn-outline-primary" @click="expanded = !expanded">
        {{ expanded ? __DICT__.hide : __DICT__.show }}
      </button>
    </template>
    <template #default>
      <div v-if="expanded" class="table-responsive">
        <table class="table table-vcenter card-table mb-0">
          <tbody>
            <tr v-for="row in rows" :key="row.key" data-test="personal-detail" :data-key="row.key">
              <td class="w-50 text-muted">{{ row.label }}</td>
              <td>
                <div v-for="(line, i) in row.lines" :key="i">{{ line }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Card } from "@/components/atomic";
import { personalDetailRows } from '@/utils/personalDetails.js'

const props = defineProps({
  // The rep's Current Database row from GET /api/mySeason/database
  databaseData: {
    type: Object,
    default: () => ({}),
  },
})

const expanded = ref(false) // default collapsed

// Field list and per-brand labels live in utils/personalDetails.js;
// __DICT__ is the compiled brand dictionary.
const rows = computed(() => personalDetailRows(props.databaseData, __DICT__))
</script>
